import axios from 'utils/axios';
import { EnqueueSnackbar } from 'notistack';
import UserModel from 'models/UserModel';
import { error } from 'console';
const walletUrl = import.meta.env.VITE_APP_WALLET_URL;
const hpslwalletUrl = import.meta.env.VITE_APP_HPSL_WALLET_URL;
/*
 * Get Game Category Events.
 */

export const getGeoData = async () => {
    try {
        const result = await axios.get(`${import.meta.env.VITE_APP_API_URL}/handlerGetUserGeoLocation`);
        if (result.status === 200) {
            return result.data;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        return { status: 'error', message: error?.response?.data.message };
    }
};

// Function definition
export const createGcashOrder = async ({ amount, theme }: { amount: number; theme: string }): Promise<{ url: string }> => {
    try {
        const result = await axios.post(`${walletUrl}/razorpay/creategcashorder`, { amount, theme });
        if (result.status === 200) {
            return {
                url: result.data.body.url
            };
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        throw error.response.data.message;
    }
    return null as any;
};


// Function definition
export const createStarpayOrder = async ({ amount, theme }: { amount: number; theme: string }): Promise<{ url: string }> => {
    try {
        const result = await axios.post(`${walletUrl}/starpay/createstarpayorder`, { amount, theme });
        if (result.status === 200) {
            return {
                url: result.data.body.url
            };
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        throw error.response.data.message;
    }
    return null as any;
};

export const createOrder = async ({ amount }: { amount: number }): Promise<{ depositId: string } | null> => {
    try {
        const result = await axios.post(`${hpslwalletUrl}/createorder`, { amount });
        if (result.status === 200) {
            // TODO Just in case - add user to a context always when called?
            //  return result.data;
            return {
                depositId: result.data.body.depositId
            };
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        throw error.response.data.message;
        // throw new Error('Something went wrong!');
    }
    return null;
};

/*
 * Get Game Category Events.
 */
export const apiGetCurrentUser = async (errorEnqueueSnackbar: null | EnqueueSnackbar = null): Promise<UserModel | null> => {
    try {
        const result = await axios.get(`${import.meta.env.VITE_APP_API_URL}/user`);
        if (result.status === 200) {
            // TODO Just in case - add user to a context always when called?
            //  return result.data;
            return result.data.body as UserModel;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        console.error(error);
        if (errorEnqueueSnackbar) {
            errorEnqueueSnackbar(`${error.message}: ${error.response?.data?.error || 'n/a'}`, {
                variant: 'error',
                autoHideDuration: 1000
            });
        }
    }
    return null;
};

export const getUserUpdate = async (values: any) => {
    try {
        const result = await axios.post(`${import.meta.env.VITE_APP_API_URL}/signup/user/update`, values);
        if (result.status === 200) {
            // TODO Just in case - add user to a context always when called?
            return result.data.body as UserModel;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        console.error(error);
        // if (errorEnqueueSnackbar) {
        //     errorEnqueueSnackbar(`${error.message}: ${error.response?.data?.error || 'n/a'}`, {
        //         variant: 'error',
        //         autoHideDuration: 1000
        //     });
        // }
    }
    return null;
};

export const userGcashWithdraw = async (values: any) => {
    try {
        const response = await axios.post(`${import.meta.env.VITE_APP_WALLET_URL}/walletwithdraw`, values);
        return { status: true, data: response.data };
    } catch (err: any) {
        const errorMessage = err.response?.data?.error?.error || err.response?.data?.message || err.message || 'Something went wrong';

        const errorCode = err.response?.data?.error?.errorCode || err.response?.status || 500;

        return {
            status: false,
            error: errorMessage,
            errorCode
        };
    }
};

export const updateKyc = async (values: any) => {
    try {
        const formData = new FormData();

        for (const key in values) {
            if (values[key]) {
                formData.append(key, values[key]);
            }
        }

        const result = await axios.put(`${import.meta.env.VITE_APP_API_URL}/kyc`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        if (result.status === 200) {
            // TODO Just in case - add user to a context always when called?
            return result.data.body as UserModel;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        console.error(error);
    }
    return null;
};

export const updateKycAddress = async (values: any) => {
    try {
        const result = await axios.put(`${import.meta.env.VITE_APP_API_URL}/kycaddress`, values);
        if (result.status === 200) {
            // TODO Just in case - add user to a context always when called?
            return result.data.body as UserModel;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        console.error(error);
    }
    return null;
};

export const sendMobileOtp = async (values: any) => {
    try {
        const result = await axios.post(`${import.meta.env.VITE_APP_API_URL}/signin/phone/otp`, { phone: values });
        if (result.status === 200) {
            return result.data;
        } else {
            console.error(`Not a 200 OK, but ${result.status}`);
        }
    } catch (error: any) {
        return { status: 'error', message: error?.response?.data.message };
    }
};
